import { TopBar } from "../common/TopBar";
import { useEffect, useState } from "react";
import { LoginService } from "@propertelligent/client-api";
import { useParams, useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import "./ResetPassword.css";
import apiHelper from "../../utils/apiHelper";
import CustomInputs from "../common/Inputs";
import AddButtonWithArrow from "../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { useError } from "../../utils/context/ErrorContext";
import { checkEmptyFieldsFunc, validatePassword } from "../../utils/validateHelper";
import { loginResponseHandler } from "../../services/login.service";
import { usePermissions } from "../../hooks/usePermissions";

const PASSWORD_MISMATCH_MESSAGE = "Confirm password must match password";

const ResetPassword = () => {
  const { userKey } = useParams();
  const location = useLocation();
  const isSetup = location.pathname.startsWith("/setpassword/");
  const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const { refreshPermissions } = usePermissions();

  const setPassword = (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setErrors((prev) => ({ ...prev, confirmPassword: true }));
      setErrorMessages((prev) => ({ ...prev, confirmPassword: PASSWORD_MISMATCH_MESSAGE }));
      return;
    }

    const payload = { guid: userKey, password: newPassword };
    validatePassword(newPassword, setErrors, setErrorMessages);
    if (checkEmptyFieldsFunc(payload, clearErrors, errors, errorMessages, setErrors, setErrorMessages, undefined)) {
      return;
    }

    apiHelper(LoginService.postApiLoginSetPassword, {
      successMessage: isSetup ? "Password set successfully" : "Password reset successfully",
      failureMessage: "Error updating password",
      showNotification: true,
    }, payload)
      .then((res) => {
        if (res?.data?.success) {
          loginResponseHandler(res);
          refreshPermissions();
          navigate("/");
        }
      })
      .catch(() => {});
  };

  return (
    <>
      <div className="background-section background-image">
        <div className="reset-pass-container">
          <TopBar haveAccount="Don't have an account?" signInUp="Sign up" />
          <div className="form-container-main">
            <form className="form-container" onSubmit={setPassword}>
              <p className="top_header mb-4 black">
                {isSetup ? "Set Up Your Password" : "Reset password"}
              </p>
              <div className="input-container">
                <CustomInputs
                  myClassName="input-field normal_text"
                  labelText="New password"
                  type="password"
                  placeholder="New password"
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, password: false }));
                    setErrorMessages((prev) => ({ ...prev, password: "" }));
                  }}
                  onBlur={() => validatePassword(newPassword, setErrors, setErrorMessages)}
                  required
                  isPassword={true}
                  isError={errors?.password}
                  errorMessages={errorMessages?.password}
                />
              </div>
              <div className="confirm-password-container">
                <div className="input-container">
                  <CustomInputs
                    labelText="Re-enter new password"
                    myClassName="input-field normal_text"
                    type="password"
                    placeholder="Re-enter new password"
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      setErrors((prev) => ({ ...prev, confirmPassword: false }));
                      setErrorMessages((prev) => ({ ...prev, confirmPassword: "" }));
                    }}
                    onBlur={() => {
                      const isMismatch = newPassword !== confirmPassword;
                      setErrors((prev) => ({ ...prev, confirmPassword: isMismatch }));
                      setErrorMessages((prev) => ({
                        ...prev,
                        confirmPassword: isMismatch ? PASSWORD_MISMATCH_MESSAGE : "",
                      }));
                    }}
                    required
                    isPassword={true}
                    isError={errors?.confirmPassword}
                    errorMessages={errorMessages?.confirmPassword}
                  />
                </div>
              </div>
              <AddButtonWithArrow
                type="submit"
                buttonname={isSetup ? "Set Password" : "Reset Password"}
                className="w-100"
              />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
